module.exports = ->
    _.keys @attributes



// WEBPACK FOOTER //
// ./app/jsmodel/Backbone.Model.keys.coffee